exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* UU5.Forms.Slider */\n.uu5-forms-slider .uu5-forms-slider-input-group {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-align-items: center;\n  align-items: center;\n}\n.uu5-forms-slider-slider {\n  width: calc(93%);\n  display: inline-block;\n}\n.uu5-forms-slider-number {\n  width: 7em;\n  display: inline-block;\n  margin-bottom: 0;\n}\n.uu5-forms-slider-number .uu5-forms-input-wrapper {\n  padding-right: 0;\n}\n.uu5-forms-slider .uu5-forms-input-wrapper {\n  display: table;\n}\n.uu5-forms-slider .uu5-forms-input-wrapper .uu5-bricks-slider {\n  display: table-cell;\n  width: 100%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./forms/slider.less
// module id = 331
// module chunks = 0